export const getMaxValue = (maxValue: number | string, freeMaxValue: number | string): number | string => {
	if (freeMaxValue === 'inf') return '∞';
	if ((maxValue === 'inf' || typeof maxValue === 'number') && freeMaxValue !== 'inf') return freeMaxValue;
	return maxValue;
};
